export default __webpack_public_path__ + "9e9ab878454b5963871ad68f193e61f7.svg";